import { styled } from '@mui/material/styles';
import { useAlert } from 'shared/components/alerts';
import { Box, buttonClasses } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { useWorkerExistsByEmail } from 'shared/hooks/query-hooks/use-worker-exists-by-email';
import { FlexWorkerLevelFilters } from 'shared/services/worker-service.types';
import { PublicButton } from 'public/components/common/button/button';
import { FormEmailInput } from 'public/components/common/forms';

export const EmailFormStep = ({
  onSuccess,
  verified = false,
  level = FlexWorkerLevelFilters.COMPLETE,
}: {
  onSuccess: () => void;
  verified?: boolean;
  level?: FlexWorkerLevelFilters;
}) => {
  const { t } = useTranslation('web-common');
  const { trigger, getValues } = useFormContext();
  const { mutateAsync: getWorkerExistsByEmail } = useWorkerExistsByEmail(verified);
  const { alertError } = useAlert();

  const handleContinue = async () => {
    const isEmailValid = await trigger('email');
    if (!isEmailValid) {
      return;
    }

    const workerExists = await getWorkerExistsByEmail({
      email: getValues('email'),
      level,
    });

    if (!workerExists) {
      alertError(new Error(t('upload-certificate-screen.worker-not-found')));
      return;
    }

    onSuccess();
  };

  return (
    <StyledContainer>
      <FormEmailInput label={t('upload-certificate-screen.email-label')} name="email" required />
      <CenteredPublicButton variant="contained" onClick={handleContinue}>
        {t('upload-certificate-screen.continue-button')}
      </CenteredPublicButton>
    </StyledContainer>
  );
};

const StyledContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: theme.spacing(4),
  gap: theme.spacing(6),
  padding: theme.spacing(6, 8),
  width: '100%',
  maxWidth: theme.spacing(140),
}));

export const CenteredPublicButton = styled(PublicButton)({
  [`&.${buttonClasses.root}`]: {
    width: '80%',
    alignSelf: 'center',
  },
});
